var TabType = {
    Datagraph:"DATAGRAPH",
    Fundamental:"FUNDAMENTALS",
    Model:"MODEL",
    Ownership:"OWNERSHIP",
    Holdings:"HOLDINGS",
    AiInsights:"AI INSIGHTS"
};

export default TabType;
